'use client';

/** @jsxImportSource react */

import { useEffect } from 'react';

import { recordFirstTouch } from '@OnArk/utils/attribution';

/**
 * Records first-touch attribution on mount for a /start page that renders NO
 * signup form.
 *
 * Every other /start page (and /sign-up) gets this for free from
 * `SignupTrialForm`, which seeds or records the `onark-attribution` cookie on
 * mount. /start/training has no form — its CTA is a link into the free class —
 * so nothing wrote the cookie, and the later class check-in (which sends
 * `getFirstTouch()` to the checkIn mutation → Customer.io) had nothing to send.
 * Verified 2026-09-07: three people arrived from a Meta ad with full click tags
 * on the first $pageview and reached Customer.io labeled "direct".
 *
 * Mount this ONLY on pages without the form. On a page that also mounts
 * `SignupTrialForm` it would race the form's `seedFirstTouch` and could win
 * with a URL-only record, dropping the page's seeded defaults (e.g. /start/pco
 * → planningcenter). `start-first-touch-coverage.test.tsx` guards both sides.
 */
export default function FirstTouchRecorder() {
  useEffect(() => {
    recordFirstTouch();
  }, []);

  return null;
}
